import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null); // 🔥 Inicialmente null para evitar redirección prematura

  useEffect(() => {
    const checkAuth = () => {
      const liderId = localStorage.getItem("liderId");
      setIsAuthenticated(!!liderId); // ✅ Solo cambia cuando hay liderId
    };

    checkAuth();
    window.addEventListener("storage", checkAuth);

    return () => window.removeEventListener("storage", checkAuth);
  }, [location]); // 🔥 Se ejecuta cada que cambia la ruta

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        console.log("⏳ Sesión cerrada por inactividad.");
        localStorage.removeItem("liderId"); // 🔥 Elimina sesión
        window.location.href = "/"; // 🔥 Redirige al login
      }, 20 * 60 * 1000); // ⏳ 5 minutos de inactividad
    };

    if (isAuthenticated) {
      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keydown", resetTimer);
      window.addEventListener("click", resetTimer);
      resetTimer(); // Inicia el temporizador
    }

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, [isAuthenticated]);

  // 🔥 IMPORTANTE: Evitar redirección antes de que se verifique autenticación
  if (isAuthenticated === null) return null;

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
